import { IsString } from 'class-validator';

export class TaxonomyReferenceDeleteRequest {
    @IsString()
    public uuid: string;

    constructor(data?: Partial<TaxonomyReferenceDeleteRequest>) {
        this.uuid = data?.uuid;
    }
}
